"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SheetScreen = SheetScreen;
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _kbd = require("@design/ui/kbd");
var _sheet = require("./sheet.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function SheetScreen() {
  var _w$headerSheetTitle, _w$headerSheetShowDes, _w$headerSheetDescrip, _w$sheetSlot, _w$sheetShowFooter, _w$buttonShowIconStar, _w$buttonLabel, _w$buttonShowKbd, _w$kbdShowLeftIcon, _w$kbdLabel, _w$kbdShowRightIcon, _w$buttonShowIconEnd, _w$buttonShowIconStar2, _w$buttonLabel2, _w$buttonShowKbd2, _w$kbdShowLeftIcon2, _w$kbdLabel2, _w$kbdShowRightIcon2, _w$buttonShowIconEnd2, _w$sheetShowScroller;
  var w = (0, _sheet.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      alignSelf: "stretch"
    },
    "data-sentry-component": "SheetScreen",
    "data-sentry-source-file": "sheet.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "4px 4px 4px 4px",
        alignSelf: "stretch",
        maxHeight: "800px",
        backgroundColor: "rgba(255, 255, 255, 1)",
        border: "1px solid rgba(234, 231, 220, 1)",
        borderRadius: "8px 8px 0px 0px",
        boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "4px 4px 4px 4px",
          alignSelf: "stretch"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            gap: "4px",
            alignItems: "flex-start",
            padding: "4px 4px 4px 4px",
            alignSelf: "stretch"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              flexGrow: "1",
              flexBasis: "0",
              minWidth: "0",
              color: "rgba(28, 25, 23, 1)",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "24px"
            },
            children: (_w$headerSheetTitle = w.headerSheetTitle) !== null && _w$headerSheetTitle !== void 0 ? _w$headerSheetTitle : "Page title"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-start"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                width: "16px",
                maxWidth: "100%",
                height: "16px",
                borderRadius: "8px",
                opacity: "0.699999988079071"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, _objectSpread(_objectSpread({}, w.close), {}, {
                "data-sentry-element": "CloseIcon",
                "data-sentry-source-file": "sheet.tsx"
              }))
            })
          })]
        }), ((_w$headerSheetShowDes = w.headerSheetShowDescription) !== null && _w$headerSheetShowDes !== void 0 ? _w$headerSheetShowDes : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "flex-start",
            padding: "4px 4px 4px 4px",
            alignSelf: "stretch"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              alignSelf: "stretch",
              color: "rgba(100, 97, 92, 1)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px"
            },
            children: (_w$headerSheetDescrip = w.headerSheetDescription) !== null && _w$headerSheetDescrip !== void 0 ? _w$headerSheetDescrip : "Page description"
          })
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          gap: "4px",
          justifyContent: "center",
          alignItems: "safe center",
          padding: "4px 4px 4px 4px",
          alignSelf: "stretch",
          overflowY: "auto"
        },
        children: (_w$sheetSlot = w.sheetSlot) !== null && _w$sheetSlot !== void 0 ? _w$sheetSlot : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              flexGrow: "1",
              flexBasis: "0",
              minWidth: "0",
              color: "rgba(115, 115, 115, 1)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              textAlign: "center"
            },
            children: "Place content here\nOpt + ⌘"
          })
        })
      }), ((_w$sheetShowFooter = w.sheetShowFooter) !== null && _w$sheetShowFooter !== void 0 ? _w$sheetShowFooter : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "center",
          padding: "16px 16px 16px 16px",
          alignSelf: "stretch"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            alignSelf: "stretch"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button), {}, {
            variant: "outline",
            size: "sm",
            children: [((_w$buttonShowIconStar = w.buttonShowIconStart) !== null && _w$buttonShowIconStar !== void 0 ? _w$buttonShowIconStar : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(28, 25, 23, 1)"
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(100, 97, 92, 1)"
                }
              })]
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(28, 25, 23, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: (_w$buttonLabel = w.buttonLabel) !== null && _w$buttonLabel !== void 0 ? _w$buttonLabel : "Cancel"
            }), ((_w$buttonShowKbd = w.buttonShowKbd) !== null && _w$buttonShowKbd !== void 0 ? _w$buttonShowKbd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd), {}, {
              children: [((_w$kbdShowLeftIcon = w.kbdShowLeftIcon) !== null && _w$kbdShowLeftIcon !== void 0 ? _w$kbdShowLeftIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(100, 97, 92, 1)"
                    }
                  })
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(100, 97, 92, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px",
                  textAlign: "center"
                },
                children: (_w$kbdLabel = w.kbdLabel) !== null && _w$kbdLabel !== void 0 ? _w$kbdLabel : "⌘"
              }), ((_w$kbdShowRightIcon = w.kbdShowRightIcon) !== null && _w$kbdShowRightIcon !== void 0 ? _w$kbdShowRightIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(100, 97, 92, 1)"
                    }
                  })
                })
              }) : null]
            })) : null, ((_w$buttonShowIconEnd = w.buttonShowIconEnd) !== null && _w$buttonShowIconEnd !== void 0 ? _w$buttonShowIconEnd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(28, 25, 23, 1)"
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(100, 97, 92, 1)"
                }
              })]
            }) : null]
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button2), {}, {
            variant: "default",
            size: "sm",
            children: [((_w$buttonShowIconStar2 = w.buttonShowIconStart2) !== null && _w$buttonShowIconStar2 !== void 0 ? _w$buttonShowIconStar2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(28, 25, 23, 1)"
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(100, 97, 92, 1)"
                }
              })]
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(255, 255, 255, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: (_w$buttonLabel2 = w.buttonLabel2) !== null && _w$buttonLabel2 !== void 0 ? _w$buttonLabel2 : "Save Changes"
            }), ((_w$buttonShowKbd2 = w.buttonShowKbd2) !== null && _w$buttonShowKbd2 !== void 0 ? _w$buttonShowKbd2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd2), {}, {
              children: [((_w$kbdShowLeftIcon2 = w.kbdShowLeftIcon2) !== null && _w$kbdShowLeftIcon2 !== void 0 ? _w$kbdShowLeftIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(100, 97, 92, 1)"
                    }
                  })
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(100, 97, 92, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px",
                  textAlign: "center"
                },
                children: (_w$kbdLabel2 = w.kbdLabel2) !== null && _w$kbdLabel2 !== void 0 ? _w$kbdLabel2 : "⌘"
              }), ((_w$kbdShowRightIcon2 = w.kbdShowRightIcon2) !== null && _w$kbdShowRightIcon2 !== void 0 ? _w$kbdShowRightIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(100, 97, 92, 1)"
                    }
                  })
                })
              }) : null]
            })) : null, ((_w$buttonShowIconEnd2 = w.buttonShowIconEnd2) !== null && _w$buttonShowIconEnd2 !== void 0 ? _w$buttonShowIconEnd2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(28, 25, 23, 1)"
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  backgroundColor: "rgba(100, 97, 92, 1)"
                }
              })]
            }) : null]
          }))]
        })
      }) : null, ((_w$sheetShowScroller = w.sheetShowScroller) !== null && _w$sheetShowScroller !== void 0 ? _w$sheetShowScroller : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          alignSelf: "stretch",
          height: "40px",
          position: "absolute",
          left: "4px",
          right: "4px",
          width: "auto",
          bottom: "68px",
          backgroundImage: "linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 0px 16px 0px",
            borderRadius: "9999px"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({}, w.button3), {}, {
            variant: "outline",
            size: "icon-xs",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, _objectSpread({}, w.iconCaretDown))
          }))
        })
      }) : null]
    })
  });
}